import React from 'react';

type StatusType =
  | 'active' |'pending' |'suspended' |'verified' |'unverified' |'completed' |'disputed' |'inprogress' |'cancelled' |'assigned' |'posted' |'open' |'mediation' |'resolved' |'escalated' |'approved' |'rejected' |'under_review' |'removed';

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
  size?: 'sm' | 'md';
}

const statusConfig: Record<StatusType, { bg: string; text: string; dot: string; label: string }> = {
  active: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500', label: 'Active' },
  pending: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-500', label: 'Pending' },
  suspended: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-500', label: 'Suspended' },
  verified: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'bg-blue-500', label: 'Verified' },
  unverified: { bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-400', label: 'Unverified' },
  completed: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500', label: 'Completed' },
  disputed: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-500', label: 'Disputed' },
  inprogress: { bg: 'bg-purple-50', text: 'text-purple-700', dot: 'bg-purple-500', label: 'In Progress' },
  cancelled: { bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-400', label: 'Cancelled' },
  assigned: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'bg-blue-500', label: 'Assigned' },
  posted: { bg: 'bg-sky-50', text: 'text-sky-700', dot: 'bg-sky-500', label: 'Posted' },
  open: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-500', label: 'Open' },
  mediation: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-500', label: 'In Mediation' },
  resolved: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500', label: 'Resolved' },
  escalated: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-600', label: 'Escalated' },
  approved: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500', label: 'Approved' },
  rejected: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-500', label: 'Rejected' },
  under_review: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'bg-blue-500', label: 'Under Review' },
  removed: { bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-400', label: 'Removed' },
};

export default function StatusBadge({ status, label, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig['pending'];
  const displayLabel = label ?? config.label;

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-500 rounded-full ${config.bg} ${config.text} ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs'
      }`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot} shrink-0`} />
      {displayLabel}
    </span>
  );
}